/* eslint-disable linebreak-style */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
import React from 'react';

import { Fade } from 'react-awesome-reveal';

// eslint-disable-next-line import/no-extraneous-dependencies
import {
  Tab, Tabs, TabList, TabPanel,
} from 'react-tabs';

import Button from 'elements/Button';

const renderCard = (item, index) => (
  <Fade triggerOnce direction="up" delay={150 * index} key={item.id}>
    <Button type="link" href={`/programs/${item.id}`}>
      <div className="group rounded-2xl shadow-xl w-auto m-3 transform transition duration-500 hover:scale-105 portofolio-card bg-white">
        <div className="relative">
          <img src={item.imageUrl} alt={item.title} className="rounded-t-2xl z-0 w-full" />
          <div className="absolute flex w-full h-full top-0 opacity-0 bg-theme-blue justify-center items-center rounded-t-2xl rounded-b img-hover">
            <span className="text-gray-200 text-base font-medium px-4 text-center">
              View {item.type === 'Program' ? 'program' : 'showcase'}
            </span>
          </div>
        </div>
        <div className="py-4 px-3">
          <h2 className="text-theme-blue text-center text-xl font-semibold">{item.title}</h2>
          <p className="font-light text-gray-400 text-center text-sm">{item.type}</p>
        </div>
      </div>
    </Button>
  </Fade>
);

export default function AllPortfolio({ data }) {
  const programs = data.filter((item) => item.type === 'Program');
  const showcases = data.filter((item) => item.type === 'Showcase');

  const tabBtn = 'font-normal px-5 py-2 mr-3 text-theme-purple text-lg border border-theme-purple rounded-full transition duration-300 hover:bg-theme-purple hover:text-white focus:outline-none focus:bg-theme-purple focus:text-white';

  return (
    <Fade triggerOnce>
      <section className="container mx-auto">
        <Tabs className="flex flex-col px-4">
          <TabList>
            <div className="flex flex-row mb-5 flex-wrap gap-2">
              <Tab>
                <button className={tabBtn}>All</button>
              </Tab>
              <Tab>
                <button className={tabBtn}>Programs</button>
              </Tab>
              <Tab>
                <button className={tabBtn}>Showcases</button>
              </Tab>
            </div>
          </TabList>

          <TabPanel>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 sm:gap-2 xl:gap-8 justify-items-center">
              {data.map((item, index) => renderCard(item, index))}
            </div>
          </TabPanel>
          <TabPanel>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 sm:gap-2 xl:gap-8 justify-items-center">
              {programs.map((item, index) => renderCard(item, index))}
            </div>
          </TabPanel>
          <TabPanel>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 sm:gap-2 xl:gap-8 justify-items-center">
              {showcases.length > 0
                ? showcases.map((item, index) => renderCard(item, index))
                : (
                  <p className="font-light text-gray-400 col-span-full text-center py-12">
                    No showcases scheduled yet — check back soon.
                  </p>
                )}
            </div>
          </TabPanel>
        </Tabs>
      </section>
    </Fade>
  );
}
